import frUtils from '../util/frUtils';

(function ($) {
    let $orgSelect, $countrySelect, $orgToggle;
    let $countryToggle;
    let $orgChangeOnLoad = false, $countryChangeOnLoad = false;

    $.fn.partnerGrid = function () {

        return this.each((index, block) => {
            const $self = $(block);
            let $partnerPageContainer = $('.partners-grid-container');
            $orgSelect = $($self).find('.orgSelect .custom-select');
            $countrySelect = $($self).find('.locationSelect .custom-select');
            $countryToggle = $($self).find('#country_input-dropdown');
            $orgToggle = $($self).find('#org_input-dropdown');

            $('.cat-band input[type="radio"]').on('click', function () {
                var id = $(this).attr('id');
                frUtils.addHistoryUrlParam('organization', id);
                filter($self);
            });

            // On org change
            $orgSelect.on('fr:update-custom-select', () => {
                // If event fired on page load
                if($orgChangeOnLoad){
                    return;
                }

                var selectVal = $($orgToggle).val();
                selectVal = selectVal == '' ? 'all-partner' : selectVal;

                let radioInput = document.getElementById(selectVal);
                radioInput.checked = true;

                frUtils.addHistoryUrlParam('organization', selectVal);
                filter($self);
            });

            // On country change
            $countrySelect.on('fr:update-custom-select', () => {
                // If event fired on page load
                if($countryChangeOnLoad){
                    return;
                }
                
                var selectVal = $($countryToggle).val();
                selectVal = selectVal == '' ? 'all-location' : selectVal;

                frUtils.addHistoryUrlParam('country', selectVal);
                filter($self);
            });

            //partner bio popup
            $partnerPageContainer.on('click', '.partner-modal-link', function (e) {
                e.preventDefault();

                var dataUrl = $(this).attr('data-url');
                frUtils.setUrlHash(dataUrl);

                var partnerId = $(this).attr('id');
                partnerDataBio(partnerId, $self);
            });

            setFiltersOnLoading($self);
        });
    }

    // Function to set filters value on loading
    const setFiltersOnLoading = ($block) => {

        let urlParams = frUtils.getUrlParams();
        const $countryDropdownItems = $('.locationSelect').find('.dropdown-item');
        const $orgDropdownItems = $('.orgSelect').find('.dropdown-item');
    

        // Set organisation
        if (urlParams.hasOwnProperty('organization')) {
            $orgChangeOnLoad = true;
            
            let radioInput = document.getElementById(urlParams.organization);
            radioInput.checked = true;
            
            $orgDropdownItems.each((index, $dropdown) => {
                if ($($dropdown).attr('data-value') === urlParams.organization) {
                    $($dropdown).trigger('click');
                    
                    return false;
                }
            });
        }

        // Set country
        if (urlParams.hasOwnProperty('country')) {
            $countryDropdownItems.each((index, $dropdown) => {
                if ($($dropdown).attr('data-value') === urlParams.country) {
                    $countryChangeOnLoad = true;
                    $($dropdown).trigger('click');
                    return false;
                }
            });
        }

        // Load filter
        if ($orgChangeOnLoad || $countryChangeOnLoad) {
            filter($block);
        }
        else {
            modalOpenOnUrl();
        }

        // Reset flag
        $orgChangeOnLoad = false;
        $countryChangeOnLoad = false;
    }

    modalOpenOnUrl();

    function partnerDataBio(partnerId, $block) {
        console.log('sorigin');
        $($block).find('.ajax-loading').addClass('wrap-loading');
        $($block).find('.ajax-loading').show();
        let $modalId = $block.attr('data-modal');
        let $modal = $($block).find('#' + $modalId);

        $.frAjax({
            action: 'partnerGridBio',
            data: {
                partnerId: partnerId,
            },
        })
            .then(data => {
                
                $($modal[0]).find('.modal-body').html(data);
                $.frModalOpen($modal[0]);
                $($block).find('.ajax-loading').removeClass('wrap-loading');
                $($block).find('.ajax-loading').hide();

            })
            .catch(err => {
                console.error(err);
            });
        return this;
    }

    function filter($block) {
        $($block).find('.partner-detail').html('');
        $($block).find('.ajax-loading').show();
        var countryVal = $($countryToggle).val();

        $.frAjax({
            action: 'partnerFilter',
            data: $($block).find('#partnerFilterForm').serialize() + '&location=' + countryVal,
        })
            .then(data => {
                if (data == '') {
                    $($block).find('.ajax-loading').hide();
                    $($block).find('.partner-detail').html('<p>No Partner found.</p>');
                }
                else {
                    $($block).find('.partner-detail').html(data);
                    $($block).find('.ajax-loading').hide();
                }

                modalOpenOnUrl();

            })
            .catch(err => {
                console.error(err);
            });
    }

    function modalOpenOnUrl() {
        // Don't do anything if hash not present
        if (!frUtils.urlHashValue) {
            return;
        }

        $('.partner-detail .partner-logo').each(function () {
            var dataUrl = $(this).attr('data-url');
            if (dataUrl === frUtils.urlHashValue) {
                $(this).trigger('click');
                return false;
            }
        });
    }

    $(() => {
        $('.ajax-loading').hide();
        $('.partners-grid-container').partnerGrid();

        setWidth();
        $( window ).on('resize', function() { 
            setWidth();
        });

        function setWidth() {
            if($('body').find('.main-content-wrapper .partners-grid-container')) {
                var wrapperWidth = $('body').find('.main-content-wrapper').width();
                $('body').find('.main-content-wrapper .partners-grid-container').width(wrapperWidth);
            }
        }
    })

})($);


// WEBPACK FOOTER //
// ./scripts/components/partner-grid.js